import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'getElementFromDatasource'
})
export class GetElementFromDatasourcePipe implements PipeTransform {

  transform(value: unknown, ...args: unknown[]): unknown {
    return null;
  }

}
